export const SET_SC_ROLES_LOADING = 'SET_SC_ROLES_LOADING'
export const SET_SC_ROLES = 'SET_SC_ROLES'
export const ADD_SC_ROLES = 'ADD_SC_ROLES'
export const EDIT_SC_ROLES = 'EDIT_SC_ROLES'
export const DELETE_SC_ROLES = 'DELETE_SC_ROLES'